module.exports = require("../export-contract.js")(
  require("../patterns/fr.js")
);
